import React, { Component, PropTypes } from 'react';

class Checkbox extends Component {
  state = {
    isChecked: this.props.ischecked,
  }

  toggleCheckboxChange = () => {
    const { handleCheckboxChange, label } = this.props;

    this.setState(({ isChecked }) => (
      {
        isChecked: !isChecked,
      }
    ));

    handleCheckboxChange(label);
  }

  render() {
    const { label } = this.props;
    const { isChecked } = this.state;

    const containerStyle = {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
    };

    const inputStyle = {
      marginRight: label ? '8px' : '0px',
      cursor: 'pointer',
    };

    return (
      <div className="checkbox" style={containerStyle}>
        <label style={{ display: 'flex', alignItems: 'center', margin: 0, cursor: 'pointer', width: '100%' }}>
          <input
            type="checkbox"
            value={label}
            checked={isChecked}
            onChange={this.toggleCheckboxChange}
            style={inputStyle}
          />
          {label && <span>{label}</span>}
        </label>
      </div>
    );
  }
}

export default Checkbox;
